import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
declare var $: any;
import { Router, ActivatedRoute } from '@angular/router';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { KycService } from '../../services/kyc.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import swal from 'sweetalert2';
@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html'
})
export class AdminHeaderComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};
  user: any;
  file: any;
  loading: boolean = false;
  response: any;
  tabStatus = 'justified';

  public isCollapsed = false;

  public innerWidth: any;
  public defaultSidebar: any;
  public showSettings = false;
  public showMobileMenu = false;
  public expandLogo = false;

  options = {
    theme: 'light', // two possible values: light, dark
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'vertical', // fixed value. shouldn't be changed.
    sidebartype: 'iconbar', // four possible values: full, iconbar, overlay, mini-sidebar 
    sidebarpos: 'fixed', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    navbarbg: 'skin5', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin5', // six possible values: skin(1/2/3/4/5/6)
    logobg: 'skin5' // six possible values: skin(1/2/3/4/5/6)
  };
  title: any;
  constructor(private modalService: NgbModal,private _httpService: KycService, private toastr: ToastrService, private router: Router, private fb:FormBuilder) { 

  }
  

  // On file Select
  onChange(event) {
    this.file = event.target.files[0];
    console.log("in onchange", event)
  } 


  toggleSidebarType() {
    switch (this.options.sidebartype) {
      case 'full':
      case 'iconbar':
        this.options.sidebartype = 'mini-sidebar';
        break;

      case 'overlay':
        this.showMobileMenu = !this.showMobileMenu;
        break;

      case 'mini-sidebar':
        if (this.defaultSidebar === 'mini-sidebar') {
          this.options.sidebartype = 'full';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }
  handleImgError(error) {
    console.log('error', error.message);
    console.log('status code', error.responseStatus);
    if (error.responseStatus === 400) {
      console.log('inside if');
    swal({
        
        text: error.message,
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#535BE2',
        cancelButtonColor: '#FF7E39',
        confirmButtonText: 'OK',
      }).then((confirm) => {
        if (confirm) {
          // console.log("this.router.navigate(['/seller/invoice']);")
            // this.router.navigate(['/seller/invoice']);
        }
        });
    }
    if (error.responseStatus === 401) {
        console.log('inside if');
      console.log(error);
      console.log(error.message);
      console.log(error.message);
      swal({
          
          text: error.message,
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#535BE2',
          cancelButtonColor: '#FF7E39',
          confirmButtonText: 'OK',
        }).then((confirm) => {
              if (confirm) {
                this.router.navigate(['/login']);
              }
            });
      }
      if (error.responseStatus === 500) {
        console.log('inside if');
      swal({
          
          text: error.message,
          type: 'success',
          showCancelButton: false,
          confirmButtonColor: '#535BE2',
          cancelButtonColor: '#FF7E39',
          confirmButtonText: 'OK',
        }).then((confirm) => {
              if (confirm) {
               console.log( "this.router.navigate(['/admin/kyc'])")
              }
        });
      }
  }

  ngOnInit() {
    document.body.classList.remove('bg-img');
    this.user = localStorage.getItem('KycUserName');
     
    }
    onLogout() {
      this._httpService.logOut().subscribe(
        data => {
          console.log(data)
            } ,
        error => {
          console.log(error)
          },
        () => console.log('created employee', ));
      console.log('inside logout');
      // localStorage.setItem('buyertoken', null);
      // localStorage.setItem('bankerRole', null);
      localStorage.removeItem('currentUser');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('bankerRole');
      this.router.navigate(['/login']);
    }
  }
